<template>
    <div>
        <v-container>
            <v-row>
                <v-col>
                    <insurance-company-combo 
                        v-model="selectedInsuranceCompany" 
                        label="保險公司" 
                        :rules="[ v => !!v || '請選擇/輸入保險公司名稱' ]">
                    </insurance-company-combo >
                    {{this.selectedInsuranceCompany}}
                    <v-btn @click="setCompany"
                    >Set Company</v-btn>
                </v-col>
                <v-col>
                    <v-combobox
                        v-model="selectedInsuranceProduct"
                        label='保險商品名稱'
                        :rules="[ v => !!v || '請選擇/輸入保險商品名稱' ]"
                        :items='insuranceProducts'
                        item-text='name'
                        clearable
                    ></v-combobox>
                    {{selectedInsuranceProduct}}
                    <v-btn @click="setProduct">Set Product</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-combobox
                    v-model="model"
                    :filter="filter"
                    :items="items"
                    label="測試業務員"
                    item-text="name"
                    clearable
                >

                </v-combobox>        
                {{this.selectModelId}}-{{this.selectModelName}}
            </v-row>
            <v-row>
                <city-autocomplete
                    @changeVal="handleCityChange"
                    label="城市"
                    v-model="city"
                    :disabled="disableHolder"
                    :rules="[(v) => !((v === null) || (v.name === null) || (v.name=='')) || '請填寫縣市']"
                ></city-autocomplete>
                <v-btn  @click="toggleDisable = !toggleDisable">Set Disabled Attribute</v-btn>
            </v-row>
            <v-btn small @click="setData">Set</v-btn>
            <v-btn :disabled="saveDialog" :loading="saveDialog" @click="doSave">Save Dialog</v-btn>
            <v-dialog v-model="saveDialog" max-width="400">
                <div v-if="onSaving">
                    <v-card  max-width="400">
                        <v-card-title>存檔中請稍候</v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-progress-circular :size="70" indeterminate class="primary--text" />
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </div>
                <div v-else>
                    <v-card  max-width="400">
                        <v-card-title>存檔已完成</v-card-title>
                        <v-card-text>請問您接下來想要做什麼？</v-card-text>
                        
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" class="mr-2">繼續修改</v-btn>
                            <v-btn color="success" class="mr-2">新增資料</v-btn>
                            <v-btn color="primary" class="mr-2">返回列表</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </div>
            </v-dialog>
        </v-container>
    
    <div></div>
    </div>
</template>
<script>

import CityAutocomplete from '../../components/CityAutocomplete'
import InsuranceCompanyCombo from '../../components/InsuranceCompanyCombo'
import ComboBoxUtil from '../../utils/ComboBoxUtil'

export default {
    components: {
        CityAutocomplete,
        InsuranceCompanyCombo
    },
    data() {
        // data主要是用來定義本頁的view model
        return {
            toggleDisable:false,
            city:{name: null, areas:[]}, //v-model for 城市,
            selectedInsuranceCompany:{
                id:null,
                name:null,
                insurance_products:[]
            },
            selectedAgencyCompany:{
                id:null,
                name:null
            },
            selectedInsuranceProduct:{
                id:null,
                name:null
            },
            selectedSalesman:null,
            insuranceCompanyId:null,
            insuranceCompanyName:null,
            companyName:'',

            items:[
                { id: 1, name: '大業務A'},
                { id: 2, name: '小業務B'}
            ],
            model:{ id:null, name:'' },
            nonce: 0,

            saveDialog: false,
            onSaving:false,
        }
    },
    computed:{
        insuranceProducts(){
            if (this.selectedInsuranceCompany === null) {
                return []
            }
            return this.selectedInsuranceCompany.insurance_products
        },
        selectModelName(){
            return (this.model != null)? this.model.name : ''
        },

        selectModelId(){
            return (this.model != null)? this.model.id: ''
        },
        disableHolder(){
            console.log(this.toggleDisable)
            return this.toggleDisable
        },
    },
    watch:{
        /*
        saveDialog(val){
            if (!val) return
            setTimeout(()=>(this.saveDialog = false), 4000)
        },*/
        selectedInsuranceCompany(){    
            if (this.selectedInsuranceCompany === null)  {
                //清掉公司，商品也要清掉
                this.selectedInsuranceProduct = { id:null,name:null}
            } else if (typeof this.selectedInsuranceCompany === 'object') {
                //換公司，商品也要清掉
                this.selectedInsuranceProduct = { id:null,name:null}
                //this.cboInsuranceCompany.products = this.selectedInsuranceCompany.insurance_products
            } else {
                //字串
                this.selectedInsuranceProduct = { id:null,name:null}
            }

            
        },
        selectedInsuranceProduct(val,prev){
            
            console.log('selectedInsuranceProduct, selectedInsuranceProduct, before=')
            console.log(this.selectedInsuranceProduct)
            console.log('selectedInsuranceProduct, val=')
            console.log(val)
            console.log('selectedInsuranceProduct, prev=')
            console.log(prev)
            //this.cboInsuranceCompany.id = ComboBoxUtil.getSelectId(this.selectedInsuranceCompany)
            //this.cboInsuranceCompany.name = ComboBoxUtil.getSelectName(this.selectedInsuranceCompany)
            this.selectedInsuranceProduct = ComboBoxUtil.getComboBoxModel(val, this.insuranceProducts, {id: -1, name: ''})
            console.log('selectedInsuranceProduct, selectedInsuranceProduct, after=')
            console.log(this.selectedInsuranceProduct)
        },

        model(val, prev){
            //TODO prev == null
            if (val.length === prev.length) return

            this.model = this.getModel(val, prev)
            
        }
    },
    methods: {
        doSave(){
            this.saveDialog = true
            this.onSaving = true
            setTimeout(() => {
                this.onSaving = false
            }, 4000);
            
        },
        getModel(val){
            if (typeof val === 'string'){
                var v = {
                    id: -1,
                    name: val,
                }
                this.items.push(v)
                this.nonce++

                return v
            } else {
                return val
            }
        },
        setData(){
            this.selectedInsuranceCompany={
                id:3, name: "忠意", insurance_products:[]
            }

            this.selectedInsuranceProduct={
                id:20, name: "尊安保險"
            }
        },

        setCompany(){
            this.selectedInsuranceCompany = {id:13, name:"安盛", insurance_products:[]}
        },
        setProduct(){
            this.selectedInsuranceProduct = {id:40, name:"真智珍寶10 II"}
        },
        filter (item, queryText, itemText){
            const hasValue = val => val != null ? val : '' //建立內部函式hasValue，把val用=>指到一個函式，利用三元判斷val的值。

            const text = hasValue(itemText) //呼叫內部函式
            const query = hasValue(queryText)

            return text.toString()
                .toLowerCase()
                .indexOf(query.toString().toLowerCase()) > -1
        },
        handleCityChange(v) {
            console.log('handleCityChange, v=')
            console.log(v)
        },
    },
    
    setup() {
        
    },
    
}
</script>
